<template>
  <div>
    <v-app-bar app
               color="white"
               fixed
               dense
               class="main-app"
               elevation="3">
      <v-toolbar-title class="bar-title">
        {{ title }}
      </v-toolbar-title>
      <v-spacer />
      <v-divider vertical />
      <v-menu v-if="availableContextFormated.length"
              v-model="menuRayons"
              :close-on-content-click="false"
              bottom
              nudge-top="-8"
              offset-y
              min-width="230"
              max-width="230">
        <template #activator="{ on, attrs }">
          <div class="select-rayon" v-bind="attrs" v-on="on">
            <div class="logo-rayon">
              <v-img :src="'./' + formatedCurrentContext.logo" width="30px" />
            </div>
            <div>
              <div class="rayon-title">
                Rayon
              </div>
              <div class="rayon">
                {{ formatedCurrentContext.name }}
              </div>
            </div>
            <div class="ml-3 mt-1">
              <v-icon>expand_more</v-icon>
            </div>
          </div>
        </template>
        <v-card :dialog="menuRayons">
          <div v-for="context in availableContextFormated"
               :key="context.id"
               class="select-rayon pt-2 pb-2"
               @click="switchContext(context.id)">
            <div class="logo-rayon">
              <v-img :src="'./' + context.logo" width="30px" />
            </div>
            <div>
              <div class="rayon-title">
                Rayon
              </div>
              <div class="rayon">
                {{ context.name }}
              </div>
            </div>
          </div>
        </v-card>
      </v-menu>
      <v-divider vertical />
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn small
                 icon
                 color="grey"
                 class="ml-5 mr-5"
                 v-bind="attrs"
                 :disabled="zoom >= 180"
                 v-on="on"
                 @click="zoomIn">
            <v-icon class="ml-7 mr-5">
              zoom_in
            </v-icon>
          </v-btn>
        </template>
        <span>ZOOM +</span>
      </v-tooltip>
      <v-divider vertical />
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn small
                 icon
                 color="grey"
                 class="ml-5 mr-5"
                 v-bind="attrs"
                 :disabled="zoom <= 90"
                 v-on="on"
                 @click="zoomOut">
            <v-icon class="ml-7 mr-5">
              zoom_out
            </v-icon>
          </v-btn>
        </template>
        <span>ZOOM -</span>
      </v-tooltip>

      <v-divider vertical />
      <v-icon v-if="isActive" class="ml-3" color="green">
        mobile_friendly
      </v-icon>
      <v-icon v-else class="ml-3" color="red">
        mobile_off
      </v-icon>
      <div>
        <div class="line-toolbar">
          Votre tablette
        </div>
        <div class="subline-toolbar">
          Mise à jour à {{ hour }}
        </div>
      </div>
      <v-divider class="ml-3" vertical />
      <v-menu v-model="menu"
              :close-on-content-click="false"
              bottom
              nudge-top="-13"
              offset-y
              min-width="1000"
              max-width="1000">
        <template #activator="{ on, attrs }">
          <v-badge color="red" :content="notifications" :value="notifications" overlap class="ml-7 mr-5">
            <v-icon color="grey darken-1" v-bind="attrs" v-on="on">
              comment
            </v-icon>
          </v-badge>
        </template>
        <chat :dialog="menu" />
      </v-menu>
      <v-divider class="ml-3" vertical />
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <a target="_top"
             href="mailto:contact@hublot.io?subject=[HUBLOT] Demande depuis magasin.hublot.io"
             class="no-link-style">
            <v-icon color="grey darken-1" v-bind="attrs" class="ml-7 mr-5" v-on="on">mail</v-icon>
          </a>
        </template>
        <span>Envoyer un email</span>
      </v-tooltip>
      <v-divider class="ml-3" vertical />
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn small
                 icon
                 color="grey"
                 class="ml-7 mr-5"
                 v-bind="attrs"
                 v-on="on"
                 @click="logout">
            <v-icon> logout </v-icon>
          </v-btn>
        </template>
        <span>Se déconnecter</span>
      </v-tooltip>
    </v-app-bar>
  </div>
</template>

<script>
import moment from 'moment'
import {mapState} from 'vuex'

import chat from '@/components/chat.vue'

import {contextDatas} from '../store/context'

export default {
  components: {chat},
  data() {
    return {
      menu: false,
      menuRayons: false,
      zoom: 100,
      contextDatas
    }
  },
  computed: {
    formatedCurrentContext() {
      const contextData = contextDatas.find(
        context => context.id === this.currentContext
      )
      return contextData
    },
    availableContextFormated() {
      return this.contextDatas.filter(
        context =>
          this.availableContexts.find(
            availableContext => availableContext === context.id
          ) && context.id !== this.currentContext
      )
    },
    hour() {
      if (this.database.date)
        return moment(this.database.date).format('HH[:]mm')

      return '--:--'
    },
    isActive() {
      if (this.database.date)
        return moment()
          .subtract(1, 'hour')
          .isBefore(moment(this.database.date))

      return false
    },
    ...mapState({
      messages: state => state.chat.messages,
      database: state => state.database.latest,
      title: state => state.navbar.title,
      userProfile: state => state.authentication.userProfile,
      availableContexts: state => state.context.availableContexts,
      currentContext: state => state.context.currentContext,
      notifications: state => state.chat.notifications
    })
  },
  watch: {
    menu(val) {
      document.body.style.overflow = val ? 'hidden' : ''
    },
    currentContext() {
      this.updateColor()
    }
  },
  created() {
    this.$store.dispatch('getDatabase')
  },
  mounted() {
    this.updateColor()
  },
  beforeUnmount() {
    // Au cas où la modale reste ouverte lors du démontage
    document.body.style.overflow = ''
  },
  methods: {
    updateColor() {
      const contextData = this.contextDatas.find(
        availableContext => availableContext.id === this.currentContext
      )
      this.$vuetify.theme.themes.light.primary = contextData.primary
      this.$vuetify.theme.themes.light.secondary = contextData.secondary
    },
    switchContext(context) {
      this.$store.dispatch('switchContext', context)
      this.menuRayons = false
    },
    logout() {
      this.$store.dispatch('logout')
    },
    zoomOut() {
      this.zoom -= 10
      document.body.style.zoom = `${this.zoom}%`
    },
    zoomIn() {
      this.zoom += 10
      document.body.style.zoom = `${this.zoom}%`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars";

.main-app {
  padding-left: 40px !important;
}

.rayon-title {
  padding-top: 1px;
  font-weight: 400;
  line-height: 15px;
  font-size: 10pt;
  color: rgb(99, 99, 99);
}

.rayon {
  font-weight: 600;
  line-height: 18px;
  color: #616161;
  font-size: 11.5pt;
}

.logo-rayon {
  margin-top: 2px;
  padding-right: 10px;
}

.select-rayon {
  cursor: pointer;
  display: inline-flex;
  vertical-align: middle;
  padding-left: 25px;
  padding-right: 25px;
}

.chat {
  width: 200px;
  margin-right: 20px;
}

.line-toolbar {
  padding-top: 5px;
  margin-left: 15px;
  font-size: 15px;
  font-weight: 600;
  color: rgb(99, 99, 99);
  line-height: 14px;
}

.subline-toolbar {
  color: grey;
  font-size: 14px;
  margin-left: 15px;
}

.no-link-style {
  color: transparent;
}
</style>
